/**
 * Ajustes temporales de visibilidad.
 * Cambiá a `true` para rehabilitar.
 */
export const showTrayectoriaCompletaLink = false;
export const showSpeakerYCursos = true;
/** Imagen placeholder en cada ficha de /tratamientos */
export const showTratamientosImagenes = false;
